import { EmptyState, Icon } from "@validereinc/common-components";
import classNames from "classnames/bind";
import React from "react";
import styles from "./WorkflowConfigurationDrawerFinishedDetails.module.scss";
const cx = classNames.bind(styles);

const WorkflowConfigurationDrawerFinishedDetails = () => {
  return (
    <EmptyState
      title="Once all user tasks and automations have been completed, your workflow will automatically be completed."
      icon={
        <Icon
          variant="seal-check"
          size={32}
        />
      }
      className={cx("emptyState")}
    />
  );
};

export default WorkflowConfigurationDrawerFinishedDetails;
